import styled from 'styled-components';
import { black, brand, white } from 'styles/Colors';

export const Middle = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 13px;

  span {
    color: #a0a0a0;
    text-align: center;
    font-family: Lato;
    font-size: 11px;
    font-weight: 400;
    line-height: 15.4px;
    width: fit-content;
    height: 15.4px;
  }

  img {
    display: block;
    margin: 0 auto;
    height: 36px;
  }
`;

export const RightSide = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const LeftSide = styled.div`
  flex: 1;
  a {
    margin-right: 58px;
    font-family: Lato;
    font-size: 15px;
    letter-spacing: 0.5px;
    text-decoration: none;
    line-height: 80px;
    color: ${black};
    padding-bottom: 31px;
    &.active {
      font-weight: bold;
      border-bottom: 1px solid ${brand};
    }
  }
`;

export const NavBarWrapper = styled.div`
  display: flex;
  height: 80px;
  background: ${white};
  align-items: center;
  padding-left: 31px;
  padding-right: 31px;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.08);
`;
